<template>
  <div class="tab-content">
    
    <el-tabs :value="value" @input="(val) => $emit('input', val)" @tab-click="handleClick">

      <!-- time -->
      <el-tab-pane :disabled="!projectPermission.createTaskATBudgetTime" v-if="selectedRow.type !== 'project'" :label="$t('project_tab_at_budget_time')" name="timeTask">
        <el-card>
          <Rate/>
        </el-card>
      </el-tab-pane>

      <!-- material -->
      <el-tab-pane :disabled="!projectPermission.createATBudgetMaterial" v-if="selectedRow.type === 'project'" :label="$t('project_tab_at_budget_material')" name="materialProject">
        <el-card>
          <MaterialProject/>
        </el-card>
      </el-tab-pane>

      <el-tab-pane :disabled="!projectPermission.createTaskATBudgetMaterial" v-else :label="$t('project_tab_at_budget_material')" name="materialTask">
        <el-card>
          <Material ref="Material"/>
        </el-card>
      </el-tab-pane>

      <!-- summary -->
      <el-tab-pane :disabled="!projectPermission.viewATBudgetSummary" v-if="selectedRow.type === 'project'" :label="$t('project_tab_at_budget_summary')" name="summaryProject">
          Current Service Under Development
          <!-- (Summary project) -->
      </el-tab-pane>
      <el-tab-pane :disabled="!projectPermission.viewTaskATBudgetSummary" v-else :label="$t('project_tab_at_budget_summary')" name="summaryTask">
          Current Service Under Development
          <!-- (Summary) -->
      </el-tab-pane>

      <!-- analysis -->
      <el-tab-pane :disabled="!projectPermission.viewATBudgetAnalysis" v-if="selectedRow.type === 'project'" :label="$t('project_tab_at_budget_analysis')" name="analysisProject">
          Current Service Under Development
          <!-- (Analysis project) -->
      </el-tab-pane>
      <el-tab-pane :disabled="!projectPermission.viewTaskATBudgetAnalysis" v-else :label="$t('project_tab_at_budget_analysis')" name="analysisTask">
          Current Service Under Development
          <!-- (Analysis) -->
      </el-tab-pane>

    </el-tabs>

  </div>
</template>

<script>

  import axios from 'axios';
  import moment from 'moment'

  // time
  import Rate from '@/components/Projects/infoPanel/Rate.vue'

  // material
  import Material from '@/components/Projects/accountTHINK/estimate/material/Material.vue'
  import MaterialProject from '@/components/Projects/accountTHINK/estimate/material/MaterialProject.vue'

  export default {
    components: {
      Rate,
      Material,
      MaterialProject
    },
    props: [
      'isProject',
      'selectedRow',
      'value',
      'bookmarkList',
      'bookmarkListProject',
      'projectPermission'
    ],
    data() {
      return {
        activeStar: 'el-icon-star-on',
        notActiveStar: 'el-icon-star-off',
      }
    },
    methods: {
      handleClick(tab, event) {

        // history
        // if(tab.label === "History" && tab.name == "five" && this.isProject){
        //   this.$store.dispatch('getProjectHistory')
        // }
        // if(tab.label === "History" && tab.name == "five" && !this.isProject){
        //   this.$store.dispatch('getProjectTaskHistory')
        // }

        if(tab.label === "Time") {
          this.$store.dispatch('getCostType')
        }

        // Material
        if(tab.label === "Material" && tab.name == "materialTask" && !this.isProject) {
          this.$store.dispatch('getProjectMaterialDirectories', {id: this.$route.query.taskId, operation: 'create'})
        }
      },
    }
  }
</script>

<style lang="scss" scoped>

</style>